export const CONSTANTS = {
  session_user: '@session_user',
  session_tokens: '@session_tokens',
  access_token: '@access_token',
  refresh_token: '@refresh_token',
  device_token: '@device_token',
}
